/**
 * useProducerShopImages – media_assets for a producer's farm shop.
 * owner_type = 'producer_shop', owner_id = producerId.
 */

import { useMediaAssets, useCoverImageUrl, useGalleryUrls } from './useMediaAssets';
import type { VariantWidth } from '@/lib/media/mediaTypes';

export function useProducerShopImages(producerId: string | null | undefined) {
  return useMediaAssets('producer_shop', producerId);
}

export function useShopCoverUrl(
  producerId: string | null | undefined,
  variant: VariantWidth = 640,
): string | null {
  return useCoverImageUrl('producer_shop', producerId, variant);
}

export function useShopGalleryUrls(
  producerId: string | null | undefined,
  variant: VariantWidth = 640,
): string[] {
  return useGalleryUrls('producer_shop', producerId, variant);
}
